import { type ReactNode } from 'react';
import { EmptyState, type EmptyStateProps } from './EmptyState';
import { Skeleton } from './Skeleton';
import { cn } from '../lib/cn';

export interface QueryStateProps {
  isLoading?: boolean;
  isError?: boolean;
  isEmpty?: boolean;
  loadingFallback?: ReactNode;
  errorProps?: Pick<EmptyStateProps, 'title' | 'description' | 'action'>;
  emptyProps?: Pick<EmptyStateProps, 'title' | 'description' | 'action' | 'variant' | 'icon'>;
  children: ReactNode;
  className?: string;
}

export function QueryState({
  isLoading,
  isError,
  isEmpty,
  loadingFallback,
  errorProps,
  emptyProps,
  children,
  className,
}: QueryStateProps) {
  if (isLoading) {
    return (
      <div className={className}>
        {loadingFallback ?? (
          <div className="space-y-2">
            <Skeleton className="h-14 w-full" />
            <Skeleton className="h-14 w-full" />
          </div>
        )}
      </div>
    );
  }

  if (isError) {
    return (
      <div className={className}>
        <EmptyState
          variant="error"
          title={errorProps?.title ?? 'Erro ao carregar'}
          description={errorProps?.description ?? 'Tente novamente em instantes.'}
          action={errorProps?.action}
        />
      </div>
    );
  }

  if (isEmpty) {
    return (
      <div className={className}>
        <EmptyState
          variant={emptyProps?.variant ?? 'default'}
          icon={emptyProps?.icon}
          title={emptyProps?.title ?? 'Nenhum item'}
          description={emptyProps?.description}
          action={emptyProps?.action}
        />
      </div>
    );
  }

  return <div className={cn(className)}>{children}</div>;
}
